import React, { useState } from 'react';
import { Form, Button, Alert, Spinner, Row, Col } from 'react-bootstrap';
import api from '../lib/api';

const AddWidgetForm = ({ onWidgetCreated }) => {
  const [name, setName] = useState('');
  const [allowedOrigin, setAllowedOrigin] = useState('');
  const [brandName, setBrandName] = useState('CoreChat');
  const [themeColor, setThemeColor] = useState('#1D4ED8');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!name.trim() || !allowedOrigin.trim()) {
      setError('Site name and allowed origin are required');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post('/admin/widgets/', {
        name,
        allowed_origin: allowedOrigin,
        brand_name: brandName,
        theme_color: themeColor,
      });

      if (res.status >= 200 && res.status < 300) {
        setSuccess(true);
        setName('');
        setAllowedOrigin('');
        onWidgetCreated && onWidgetCreated();
      } else {
        setError('Failed to add widget');
      }
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        err?.response?.data?.error ||
        err?.message ||
        'Failed to add widget';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">Widget created successfully.</Alert>}

      <Row className="g-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Site Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="My Company"
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Allowed Origin</Form.Label>
            <Form.Control
              type="text"
              value={allowedOrigin}
              onChange={(e) => setAllowedOrigin(e.target.value)}
              placeholder="https://example.com"
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Brand Name</Form.Label>
            <Form.Control
              type="text"
              value={brandName}
              onChange={(e) => setBrandName(e.target.value)}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group>
            <Form.Label>Theme Color</Form.Label>
            <Form.Control
              type="color"
              value={themeColor}
              onChange={(e) => setThemeColor(e.target.value)}
              style={{ height: '44px' }}
            />
          </Form.Group>
        </Col>

        <Col md={3} className="d-flex align-items-end">
          <Button
            type="submit"
            disabled={loading}
            className="w-100 user-quick-action"
            style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? <Spinner animation="border" size="sm" /> : 'Create Widget'}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default AddWidgetForm;